import React from "react";
import { styled } from "styled-components";
import { rem } from "../../utils/rem";
const TrailingIconWrapper = styled.div `
  line-height: 0;
  position: absolute;
  top: 50%;
  right: ${rem(14)};
  transform: translateY(-50%);
`;
const LeadingIconWrapper = styled.div `
  line-height: 0;
  position: absolute;
  top: 50%;
  left: ${rem(14)};
  transform: translateY(-50%);
`;
export const DEFAULT_ICON_SIZE = 30;
export const LeadIcons = ({ iconColor, trailingIcon, leadingIcon, children, trailingIconSize = DEFAULT_ICON_SIZE, leadingIconSize = DEFAULT_ICON_SIZE, }) => {
    const TrailingIcon = trailingIcon;
    const LeadingIcon = leadingIcon;
    return (React.createElement(React.Fragment, null,
        LeadingIcon && (React.createElement(LeadingIconWrapper, null,
            React.createElement(LeadingIcon, { color: iconColor, height: leadingIconSize, width: leadingIconSize }))),
        children,
        TrailingIcon && (React.createElement(TrailingIconWrapper, null,
            React.createElement(TrailingIcon, { color: iconColor, height: trailingIconSize, width: trailingIconSize })))));
};
export default LeadIcons;
//# sourceMappingURL=LeadIcons.js.map